import Alphabet from './Alphabet'

export default Alphabet
